import { useSelector } from 'react-redux'
import { IAlphaprocessState } from '../store'

export default function useIsOffline() {
  return useSelector((state: IAlphaprocessState) => state.core.isOffline)
}
